import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { bool, string, func } from 'prop-types';

export default class GlobalSnackBar extends React.Component {
  static propTypes = {
    open: bool,
    message: string,
    onRequestClose: func
  };
  static defaultProps = {};

  render() {
    return <Snackbar autoHideDuration={4000} {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/GlobalSnackBar/index.js